<template>
  <div class="home">
    <transition>
      <top-frame name="topframe"></top-frame>
    </transition>
    <MainPage/>
  </div>
</template>

<script>
// @ is an alias to /src
import TopFrame from '@/components/TopFrame.vue'
import MainPage from '@/components/MainPage.vue'

export default {
  name: 'home',
  components: {
    MainPage, TopFrame
  }
}
</script>

<style lang="scss">
  .home {
    height: 100%;
  }
  .headerImage {
    position: absolute;
  }
</style>
